<div class="custom-avatar-wrap"
    [ngClass]="{'custom-avatar-wrap--second' : back != null, 'custom-avatar-wrap--icon' : displayIcon }">
    <avatar-initials class="custom-avatar custom-avatar--front" [userProfileImageUrl]="front.profileImage"
        [userFullName]="front.fullName"></avatar-initials>
    <avatar-initials class="custom-avatar custom-avatar--back" *ngIf="back != null"
        [userProfileImageUrl]="back.profileImage" [userFullName]="back.fullName"></avatar-initials>
    <div class="custom-avatar-icon-wrap" *ngIf="displayIcon">
        <rpc-icon class="custom-avatar-icon" [iconName]="iconName"></rpc-icon>
    </div>
</div>